import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "환경 변수 사용하기",
  "description": "애플리케이션의 환경을 처리하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "환경 변수 입력은 Turborepo 구성에서 고려해야 할 애플리케이션의 중요한 부분입니다."
  }, {
    "heading": "",
    "content": "Turborepo에서 환경 변수를 작업할 때 세 가지 중요한 질문이 있습니다:"
  }, {
    "heading": "",
    "content": "내 환경 변수가 작업 해시에 포함되어 있습니까?"
  }, {
    "heading": "",
    "content": "turbo가 어떤 Environment Mode를 사용합니까?"
  }, {
    "heading": "",
    "content": ".env 파일을 처리했습니까?"
  }, {
    "heading": "",
    "content": "구성에서 환경 변수를 고려하지 않으면 잘못된 구성으로 애플리케이션을 배포하게\n될 수 있습니다. 이는 프리뷰 배포를 프로덕션으로 배포하는 것과 같은 심각한\n문제를 일으킬 수 있습니다."
  }, {
    "heading": "",
    "content": "Turborepo는 자체 동작을 구성하기 위해 시스템 환경\n변수도 사용합니다. 아래에서는\n작업의 런타임을 위한 환경 변수와 작업 해싱에 미치는 영향에 대한 정보를 찾을 수\n있습니다."
  }, {
    "heading": "작업-해시에-환경-변수-추가하기",
    "content": "Turborepo는 애플리케이션 동작의 변경 사항을 고려하기 위해 환경 변수를 인식해야 합니다. 이를 위해 turbo.json 파일의 env 및 globalEnv 키를 사용합니다."
  }, {
    "heading": "작업-해시에-환경-변수-추가하기",
    "content": "globalEnv: 이 목록에 있는 환경 변수 값의 변경 사항은 모든 작업의 해시를 변경합니다."
  }, {
    "heading": "작업-해시에-환경-변수-추가하기",
    "content": "env: 작업에 영향을 미치는 환경 변수 값의 변경 사항을 포함하여 더 나은 세분성을 허용합니다. 예를 들어, lint 작업은 API_KEY 값이 변경될 때 캐시를 놓칠 필요가 없지만, build 작업은 그래야 할 가능성이 높습니다."
  }, {
    "heading": "작업-해시에-환경-변수-추가하기",
    "content": "Turborepo는 환경 변수에 대한 와일드카드를 지원하므로 특정 접두사를 가진 모든\n환경 변수를 쉽게 고려할 수 있습니다. 자세한 내용은 env에 대한 API\n참조를 참조하세요."
  }, {
    "heading": "framework-inference",
    "content": "Turborepo는 일반적인 프레임워크에 대해 env 키에 접두사 와일드카드를 자동으로 추가합니다. 패키지에서 아래 프레임워크 중 하나를 사용하는 경우, 이러한 접두사를 가진 환경 변수를 지정할 필요가 없습니다:"
  }, {
    "heading": "framework-inference",
    "content": "env wildcards"
  }, {
    "heading": "framework-inference",
    "content": "Framework Inference는 패키지별로 적용됩니다."
  }, {
    "heading": "framework-inference",
    "content": "Framework Inference를 사용하지 않으려면 다음과 같이 할 수 있습니다:"
  }, {
    "heading": "framework-inference",
    "content": "--framework-inference=false로 작업 실행하기"
  }, {
    "heading": "framework-inference",
    "content": "env 키에 부정 와일드카드 추가하기 (예: \"env\": [\"!NEXT_PUBLIC_*\"])"
  }, {
    "heading": "environment-modes",
    "content": "Turborepo의 Environment Mode를 사용하면 런타임에 작업에서 사용할 수 있는 환경 변수를 제어할 수 있습니다:"
  }, {
    "heading": "environment-modes",
    "content": "Strict Mode (기본값): turbo.json의 env 및 globalEnv 키에 지정된 환경 변수만 필터링합니다."
  }, {
    "heading": "environment-modes",
    "content": "Loose Mode: 프로세스의 모든 환경 변수를 사용할 수 있도록 허용합니다."
  }, {
    "heading": "strict-mode",
    "content": "Strict Mode는 작업의 런타임에서 사용할 수 있는 환경 변수를 turbo.json의 globalEnv 및 env 키에 지정된 환경 변수만으로 필터링합니다."
  }, {
    "heading": "strict-mode",
    "content": "즉, 필요한 모든 환경 변수를 고려하지 않은 작업은 실패할 가능성이 높습니다. 다른 환경에서 잠재적으로 다른 동작을 가질 수 있는 작업을 캐시하고 싶지 않기 때문에 이것은 좋은 일입니다."
  }, {
    "heading": "strict-mode",
    "content": "Strict Mode는 모든 환경 변수를 고려하지 않았을 때 작업이 실패할 가능성을 훨씬\n높이지만, 작업 실패를 보장하지는 않습니다. 애플리케이션이 누락된 환경 변수를\n우아하게 처리할 수 있다면 여전히 작업을 성공적으로 완료하고 의도하지 않은 캐시\n히트를 얻을 수 있습니다."
  }, {
    "heading": "passthrough-변수",
    "content": "고급 사용 사례에서는 일부 환경 변수를 해시에 포함하지 않고 작업에서 사용할 수 있도록 하고 싶을 수 있습니다. 이러한 변수의 변경 사항은 작업 출력에 영향을 미치지 않지만 작업이 성공적으로 실행되기 위해 여전히 사용할 수 있어야 합니다."
  }, {
    "heading": "passthrough-변수",
    "content": "이러한 경우 해당 환경 변수를 globalPassThroughEnv 및 passThroughEnv에 추가합니다."
  }, {
    "heading": "ci-벤더-호환성",
    "content": "Strict Mode는 env, globalEnv, passThroughEnv 또는 globalPassThroughEnv를 사용하여 고려할 때까지 CI 벤더에서 제공하는 환경 변수를 필터링합니다."
  }, {
    "heading": "ci-벤더-호환성",
    "content": "이러한 변수 중 작업에 중요하고 Framework Inference에 포함되지 않은 경우 turbo.json 구성에 포함되어 있는지 확인하세요."
  }, {
    "heading": "loose-mode",
    "content": "Loose Mode는 globalEnv 및 env 키에 따라 환경 변수를 필터링하지 않습니다. 이를 통해 Strict Mode로 점진적으로 마이그레이션하는 것을 더 쉽게 시작할 수 있습니다."
  }, {
    "heading": "loose-mode",
    "content": "스크립트에서 환경 변수를 찾을 수 없는 경우 모든 호출에서 Loose Mode를 활성화하려면 --env-mode 플래그를 사용합니다:"
  }, {
    "heading": "loose-mode",
    "content": "turbo가 실행될 때 환경 변수를 사용할 수 있는 한 스크립트에서 사용할 수 있습니다. 그러나 이는 구성에서 환경 변수를 고려하는 것을 훨씬 더 쉽게 우연히 잊어버릴 수 있게 하여 작업이 캐시에 히트해서는 안 될 때 캐시에 히트할 수 있도록 합니다."
  }, {
    "heading": "loose-mode",
    "content": "예를 들어, API에서 데이터를 가져오는 애플리케이션에 일부 코드가 있고, 기본 URL에 대한 환경 변수를 사용할 수 있습니다:"
  }, {
    "heading": "loose-mode",
    "content": "그런 다음 프리뷰 환경을 대상으로 하는 MY_API_URL 값을 사용하여 애플리케이션을 빌드합니다. 애플리케이션을 배포할 준비가 되면 프로덕션용으로 빌드하고 캐시 히트를 확인합니다 - MY_API_URL 변수 값이 변경되었음에도 불구하고! MY_API_URL이 변경되었지만 Turborepo는 프로덕션의 MY_API_URL이 아닌 프리뷰 환경의 MY_API_URL을 사용하는 애플리케이션 버전을 캐시에서 복원했습니다."
  }, {
    "heading": "loose-mode",
    "content": "Loose Mode를 사용하는 경우 MY_API_URL은 작업 해시에 고려되지 않았음에도 불구하고 작업 런타임에서 사용할 수 있습니다. 이 작업이 실패할 가능성을 높이고 이러한 잘못된 구성으로부터 보호하기 위해 Strict Mode를 선택하는 것이 좋습니다."
  }, {
    "heading": "platform-환경-변수",
    "content": "Vercel에 애플리케이션을 배포할 때 프로젝트에 이미 환경 변수가 구성되어 있을 가능성이 높습니다. Turborepo는 이러한 변수를 turbo.json 구성과 자동으로 확인하여 고려했는지 확인하고 누락된 변수에 대해 경고합니다."
  }, {
    "heading": "platform-환경-변수",
    "content": "이 기능은 TURBO_PLATFORM_ENV_DISABLED=false를 설정하여 비활성화할 수 있습니다."
  }, {
    "heading": "env-파일-처리하기",
    "content": ".env 파일은 로컬에서 애플리케이션 작업을 할 때 유용합니다. Turborepo는 .env 파일을 작업의 런타임에 로드하지 않으며, 프레임워크 또는 dotenv와 같은 도구에서 처리하도록 남겨둡니다."
  }, {
    "heading": "env-파일-처리하기",
    "content": "그러나 turbo가 .env 파일의 값 변경 사항을 알고 해싱에 사용할 수 있도록 하는 것이 중요합니다. 빌드 간에 .env 파일의 변수를 변경하면 build 작업은 캐시를 놓쳐야 합니다."
  }, {
    "heading": "env-파일-처리하기",
    "content": "이를 위해 파일을 inputs 키에 추가합니다:"
  }, {
    "heading": "여러-env-파일",
    "content": "*를 사용하여 여러 .env 파일을 한 번에 캡처할 수 있습니다."
  }, {
    "heading": "여러-env-파일",
    "content": ".env 파일은 환경 변수가 env 키에\n추가되지 않은 경우에도 작업 런타임에 변수를 로드할 수 있습니다. CI 및 프로덕션\n빌드의 경우 빌드를 위한 환경 변수를 env 키에 추가했는지 확인하세요."
  }, {
    "heading": "패키지에서-env-파일-사용하기",
    "content": "리포지토리의 루트에 .env 파일을 사용하는 것은 권장되지 않습니다. 대신 .env 파일을 사용하는 패키지에 배치하는 것이 좋습니다."
  }, {
    "heading": "패키지에서-env-파일-사용하기",
    "content": "이 방법은 환경 변수가 각 애플리케이션의 런타임에 개별적으로 존재하므로 애플리케이션의 런타임 동작을 더 밀접하게 모델링합니다. 또한 monorepo가 확장됨에 따라 이 방법을 사용하면 각 애플리케이션의 환경을 더 쉽게 관리할 수 있어 애플리케이션 간 환경 변수 누출을 방지할 수 있습니다."
  }, {
    "heading": "패키지에서-env-파일-사용하기",
    "content": "monorepo로 점진적으로 마이그레이션할 때 루트 .env 파일을 사용하는 것이 더\n쉬울 수 있습니다. dotenv와 같은 도구는\n다른 위치에서 .env 파일을 로드할 수 있습니다."
  }, {
    "heading": "eslint-config-turbo-사용하기",
    "content": "eslint-config-turbo 패키지는 turbo.json에 나열되지 않은 코드에서 사용되는 환경 변수를 찾는 데 도움이 됩니다. 이를 통해 모든 환경 변수가 구성에서 고려되도록 할 수 있습니다."
  }, {
    "heading": "런타임에-환경-변수-생성-또는-변경-피하기",
    "content": "Turborepo는 작업 시작 시 작업의 환경 변수를 해싱합니다. 작업 중에 환경 변수를 생성하거나 변경하면 Turborepo는 이러한 변경 사항을 알지 못하고 작업 해시에 고려하지 않습니다."
  }, {
    "heading": "런타임에-환경-변수-생성-또는-변경-피하기",
    "content": "예를 들어, Turborepo는 아래 예제의 인라인 변수를 감지할 수 없습니다:"
  }, {
    "heading": "런타임에-환경-변수-생성-또는-변경-피하기",
    "content": "MY_VARIABLE은 dev 작업이 시작된 후에 환경에 추가되므로 turbo는 해싱에 사용할 수 없습니다."
  }, {
    "heading": "예제",
    "content": "다음은 몇 가지 인기 있는 프레임워크에 대한 적절한 환경 변수 구성의 예입니다:"
  }, {
    "heading": "예제",
    "content": "아래 turbo.json은 다음을 표현합니다:"
  }, {
    "heading": "예제",
    "content": "build 및 dev 작업은 MY_API_URL 및 MY_API_KEY 변경 사항에 대해 서로 다른 해시를 가집니다."
  }, {
    "heading": "예제",
    "content": "build 및 dev 작업에는 Next.js에서 지원하는 .env 파일이 포함됩니다."
  }, {
    "heading": "예제",
    "content": "test 작업은 환경 변수를 사용하지 않으므로 env 키가 생략됩니다. (테스트 구조에 따라 test 작업에 env 키가 필요할 수 있습니다.)"
  }, {
    "heading": "예제",
    "content": "아래 turbo.json은 다음을 표현합니다:"
  }, {
    "heading": "예제",
    "content": "build 및 dev 작업은 MY_API_URL 및 MY_API_KEY 변경 사항에 대해 서로 다른 해시를 가집니다."
  }, {
    "heading": "예제",
    "content": "build 및 dev 작업에는 Vite에서 지원하는 .env 파일이 포함됩니다."
  }, {
    "heading": "예제",
    "content": "test 작업은 환경 변수를 사용하지 않으므로 env 키가 생략됩니다. (테스트 구조에 따라 test 작업에 env 키가 필요할 수 있습니다.)"
  }, {
    "heading": "--summarize-사용하기",
    "content": "--summarize 플래그를 turbo run 명령에 추가하여 작업에 대한 데이터를 요약하는 JSON 파일을 생성할 수 있습니다. globalEnv 및 env 키의 diff를 확인하면 구성에서 누락되었을 수 있는 환경 변수를 식별하는 데 도움이 됩니다."
  }, {
    "heading": "다음-단계",
    "content": "환경 변수를 고려했으면 turbo의 속도로 애플리케이션을 빌드하고 확인하고 배포하는 CI 파이프라인을 구축할 준비가 되었습니다."
  }],
  "headings": [{
    "id": "작업-해시에-환경-변수-추가하기",
    "content": "작업 해시에 환경 변수 추가하기"
  }, {
    "id": "framework-inference",
    "content": "Framework Inference"
  }, {
    "id": "environment-modes",
    "content": "Environment Modes"
  }, {
    "id": "strict-mode",
    "content": "Strict Mode"
  }, {
    "id": "passthrough-변수",
    "content": "Passthrough 변수"
  }, {
    "id": "ci-벤더-호환성",
    "content": "CI 벤더 호환성"
  }, {
    "id": "loose-mode",
    "content": "Loose Mode"
  }, {
    "id": "platform-환경-변수",
    "content": "Platform 환경 변수"
  }, {
    "id": "env-파일-처리하기",
    "content": ".env 파일 처리하기"
  }, {
    "id": "여러-env-파일",
    "content": "여러 .env 파일"
  }, {
    "id": "모범-사례",
    "content": "모범 사례"
  }, {
    "id": "패키지에서-env-파일-사용하기",
    "content": "패키지에서 .env 파일 사용하기"
  }, {
    "id": "eslint-config-turbo-사용하기",
    "content": "eslint-config-turbo 사용하기"
  }, {
    "id": "런타임에-환경-변수-생성-또는-변경-피하기",
    "content": "런타임에 환경 변수 생성 또는 변경 피하기"
  }, {
    "id": "예제",
    "content": "예제"
  }, {
    "id": "문제-해결",
    "content": "문제 해결"
  }, {
    "id": "--summarize-사용하기",
    "content": "--summarize 사용하기"
  }, {
    "id": "다음-단계",
    "content": "다음 단계"
  }]
};
import {Fragment} from 'react';
import {Callout} from '#components/callout';
import {Tabs, Tab} from '#components/tabs';
import {Accordion, Accordions} from '#components/accordion';
import frameworks from '@turbo/types/src/json/frameworks.json';
export const toc = [{
  depth: 2,
  url: "#작업-해시에-환경-변수-추가하기",
  title: _jsx(_Fragment, {
    children: "작업 해시에 환경 변수 추가하기"
  })
}, {
  depth: 3,
  url: "#framework-inference",
  title: _jsx(_Fragment, {
    children: "Framework Inference"
  })
}, {
  depth: 2,
  url: "#environment-modes",
  title: _jsx(_Fragment, {
    children: "Environment Modes"
  })
}, {
  depth: 3,
  url: "#strict-mode",
  title: _jsx(_Fragment, {
    children: "Strict Mode"
  })
}, {
  depth: 4,
  url: "#passthrough-변수",
  title: _jsx(_Fragment, {
    children: "Passthrough 변수"
  })
}, {
  depth: 4,
  url: "#ci-벤더-호환성",
  title: _jsx(_Fragment, {
    children: "CI 벤더 호환성"
  })
}, {
  depth: 3,
  url: "#loose-mode",
  title: _jsx(_Fragment, {
    children: "Loose Mode"
  })
}, {
  depth: 3,
  url: "#platform-환경-변수",
  title: _jsx(_Fragment, {
    children: "Platform 환경 변수"
  })
}, {
  depth: 2,
  url: "#env-파일-처리하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: ".env"
    }), " 파일 처리하기"]
  })
}, {
  depth: 3,
  url: "#여러-env-파일",
  title: _jsxs(_Fragment, {
    children: ["여러 ", _jsx("code", {
      children: ".env"
    }), " 파일"]
  })
}, {
  depth: 2,
  url: "#모범-사례",
  title: _jsx(_Fragment, {
    children: "모범 사례"
  })
}, {
  depth: 3,
  url: "#패키지에서-env-파일-사용하기",
  title: _jsxs(_Fragment, {
    children: ["패키지에서 ", _jsx("code", {
      children: ".env"
    }), " 파일 사용하기"]
  })
}, {
  depth: 3,
  url: "#eslint-config-turbo-사용하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "eslint-config-turbo"
    }), " 사용하기"]
  })
}, {
  depth: 3,
  url: "#런타임에-환경-변수-생성-또는-변경-피하기",
  title: _jsx(_Fragment, {
    children: "런타임에 환경 변수 생성 또는 변경 피하기"
  })
}, {
  depth: 2,
  url: "#예제",
  title: _jsx(_Fragment, {
    children: "예제"
  })
}, {
  depth: 2,
  url: "#문제-해결",
  title: _jsx(_Fragment, {
    children: "문제 해결"
  })
}, {
  depth: 3,
  url: "#--summarize-사용하기",
  title: _jsxs(_Fragment, {
    children: [_jsx("code", {
      children: "--summarize"
    }), " 사용하기"]
  })
}, {
  depth: 2,
  url: "#다음-단계",
  title: _jsx(_Fragment, {
    children: "다음 단계"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "환경 변수 입력은 Turborepo 구성에서 고려해야 할 애플리케이션의 중요한 부분입니다."
    }), "\n", _jsx(_components.p, {
      children: "Turborepo에서 환경 변수를 작업할 때 세 가지 중요한 질문이 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "#adding-environment-variables-to-task-hashes",
          children: "내 환경 변수가 작업 해시에 포함되어 있습니까?"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#environment-modes",
          children: [_jsx(_components.code, {
            children: "turbo"
          }), "가 어떤 Environment Mode를 사용합니까?"]
        })
      }), "\n", _jsx(_components.li, {
        children: _jsxs(_components.a, {
          href: "#handling-env-files",
          children: [_jsx(_components.code, {
            children: ".env"
          }), " 파일을 처리했습니까?"]
        })
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "error",
      children: _jsx(_components.p, {
        children: "구성에서 환경 변수를 고려하지 않으면 잘못된 구성으로 애플리케이션을 배포하게\n될 수 있습니다. 이는 프리뷰 배포를 프로덕션으로 배포하는 것과 같은 심각한\n문제를 일으킬 수 있습니다."
      })
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["Turborepo는 자체 동작을 구성하기 위해 ", _jsx(_components.a, {
          href: "/docs/reference/system-environment-variables",
          children: "시스템 환경\n변수"
        }), "도 사용합니다. 아래에서는\n작업의 런타임을 위한 환경 변수와 작업 해싱에 미치는 영향에 대한 정보를 찾을 수\n있습니다."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "작업-해시에-환경-변수-추가하기",
      children: "작업 해시에 환경 변수 추가하기"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 애플리케이션 동작의 변경 사항을 고려하기 위해 환경 변수를 인식해야 합니다. 이를 위해 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 파일의 ", _jsx(_components.code, {
        children: "env"
      }), " 및 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 키를 사용합니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalEnv\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"IMPORTANT_GLOBAL_VARIABLE\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"MY_API_URL\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"MY_API_KEY\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "globalEnv"
        }), ": 이 목록에 있는 환경 변수 값의 변경 사항은 모든 작업의 해시를 변경합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "env"
        }), ": 작업에 영향을 미치는 환경 변수 값의 변경 사항을 포함하여 더 나은 세분성을 허용합니다. 예를 들어, ", _jsx(_components.code, {
          children: "lint"
        }), " 작업은 ", _jsx(_components.code, {
          children: "API_KEY"
        }), " 값이 변경될 때 캐시를 놓칠 필요가 없지만, ", _jsx(_components.code, {
          children: "build"
        }), " 작업은 그래야 할 가능성이 높습니다."]
      }), "\n"]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["Turborepo는 환경 변수에 대한 와일드카드를 지원하므로 특정 접두사를 가진 모든\n환경 변수를 쉽게 고려할 수 있습니다. 자세한 내용은 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#wildcards",
          children: [_jsx(_components.code, {
            children: "env"
          }), "에 대한 API\n참조"]
        }), "를 참조하세요."]
      })
    }), "\n", _jsx(_components.h3, {
      id: "framework-inference",
      children: "Framework Inference"
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo는 일반적인 프레임워크에 대해 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#env",
        children: _jsx(_components.code, {
          children: "env"
        })
      }), " 키에 접두사 와일드카드를 자동으로 추가합니다. 패키지에서 아래 프레임워크 중 하나를 사용하는 경우, 이러한 접두사를 가진 환경 변수를 지정할 필요가 없습니다:"]
    }), "\n", _jsxs("table", {
      children: [_jsx("thead", {
        children: _jsxs("tr", {
          children: [_jsx("th", {
            children: "Framework"
          }), _jsx("th", {
            children: _jsx("span", {
              children: _jsxs(_components.p, {
                children: [_jsx("code", {
                  children: "env"
                }), " wildcards"]
              })
            })
          })]
        })
      }), _jsx("tbody", {
        children: frameworks.map(({name, envWildcards}) => _jsxs("tr", {
          children: [_jsx("td", {
            children: name
          }), _jsx("td", {
            children: envWildcards.map((envWildcard, index) => _jsxs(Fragment, {
              children: [index !== 0 ? _jsx("span", {
                children: ", "
              }) : null, _jsx("code", {
                children: envWildcard
              })]
            }, envWildcard))
          })]
        }, name))
      })]
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsx(_components.p, {
        children: "Framework Inference는 패키지별로 적용됩니다."
      })
    }), "\n", _jsx(_components.p, {
      children: "Framework Inference를 사용하지 않으려면 다음과 같이 할 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "--framework-inference=false"
        }), "로 작업 실행하기"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "env"
        }), " 키에 부정 와일드카드 추가하기 (예: ", _jsx(_components.code, {
          children: "\"env\": [\"!NEXT_PUBLIC_*\"]"
        }), ")"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "environment-modes",
      children: "Environment Modes"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo의 Environment Mode를 사용하면 런타임에 작업에서 사용할 수 있는 환경 변수를 제어할 수 있습니다:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#strict-mode",
          children: "Strict Mode"
        }), " (기본값): ", _jsx(_components.code, {
          children: "turbo.json"
        }), "의 ", _jsx(_components.code, {
          children: "env"
        }), " 및 ", _jsx(_components.code, {
          children: "globalEnv"
        }), " 키에 지정된 환경 변수", _jsx(_components.strong, {
          children: "만"
        }), " 필터링합니다."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#loose-mode",
          children: "Loose Mode"
        }), ": 프로세스의 모든 환경 변수를 사용할 수 있도록 허용합니다."]
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      id: "strict-mode",
      children: "Strict Mode"
    }), "\n", _jsxs(_components.p, {
      children: ["Strict Mode는 작업의 런타임에서 사용할 수 있는 환경 변수를 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "의 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 및 ", _jsx(_components.code, {
        children: "env"
      }), " 키에 지정된 환경 변수", _jsx(_components.strong, {
        children: "만"
      }), "으로 필터링합니다."]
    }), "\n", _jsx(_components.p, {
      children: "즉, 필요한 모든 환경 변수를 고려하지 않은 작업은 실패할 가능성이 높습니다. 다른 환경에서 잠재적으로 다른 동작을 가질 수 있는 작업을 캐시하고 싶지 않기 때문에 이것은 좋은 일입니다."
    }), "\n", _jsx(Callout, {
      type: "warn",
      title: "Strict Mode를 사용한 캐시 안전성",
      children: _jsx(_components.p, {
        children: "Strict Mode는 모든 환경 변수를 고려하지 않았을 때 작업이 실패할 가능성을 훨씬\n높이지만, 작업 실패를 보장하지는 않습니다. 애플리케이션이 누락된 환경 변수를\n우아하게 처리할 수 있다면 여전히 작업을 성공적으로 완료하고 의도하지 않은 캐시\n히트를 얻을 수 있습니다."
      })
    }), "\n", _jsx(_components.h4, {
      id: "passthrough-변수",
      children: "Passthrough 변수"
    }), "\n", _jsx(_components.p, {
      children: "고급 사용 사례에서는 일부 환경 변수를 해시에 포함하지 않고 작업에서 사용할 수 있도록 하고 싶을 수 있습니다. 이러한 변수의 변경 사항은 작업 출력에 영향을 미치지 않지만 작업이 성공적으로 실행되기 위해 여전히 사용할 수 있어야 합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["이러한 경우 해당 환경 변수를 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalpassthroughenv",
        children: _jsx(_components.code, {
          children: "globalPassThroughEnv"
        })
      }), " 및 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#passthroughenv",
        children: _jsx(_components.code, {
          children: "passThroughEnv"
        })
      }), "에 추가합니다."]
    }), "\n", _jsx(_components.h4, {
      id: "ci-벤더-호환성",
      children: "CI 벤더 호환성"
    }), "\n", _jsxs(_components.p, {
      children: ["Strict Mode는 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#env",
        children: _jsx(_components.code, {
          children: "env"
        })
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalenv",
        children: _jsx(_components.code, {
          children: "globalEnv"
        })
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/configuration#passthroughenv",
        children: _jsx(_components.code, {
          children: "passThroughEnv"
        })
      }), " 또는 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#globalpassthroughenv",
        children: _jsx(_components.code, {
          children: "globalPassThroughEnv"
        })
      }), "를 사용하여 고려할 때까지 CI 벤더에서 제공하는 환경 변수를 필터링합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이러한 변수 중 작업에 중요하고 ", _jsx(_components.a, {
        href: "#framework-inference",
        children: "Framework Inference"
      }), "에 포함되지 않은 경우 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 구성에 포함되어 있는지 확인하세요."]
    }), "\n", _jsx(_components.h3, {
      id: "loose-mode",
      children: "Loose Mode"
    }), "\n", _jsxs(_components.p, {
      children: ["Loose Mode는 ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 및 ", _jsx(_components.code, {
        children: "env"
      }), " 키에 따라 환경 변수를 필터링하지 않습니다. 이를 통해 Strict Mode로 점진적으로 마이그레이션하는 것을 더 쉽게 시작할 수 있습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["스크립트에서 환경 변수를 찾을 수 없는 경우 모든 호출에서 Loose Mode를 활성화하려면 ", _jsxs(_components.a, {
        href: "/docs/reference/run#--env-mode-option",
        children: [_jsx(_components.code, {
          children: "--env-mode"
        }), " 플래그"]
      }), "를 사용합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " run"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " build"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --env-mode=loose"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "turbo"
      }), "가 실행될 때 환경 변수를 사용할 수 있는 한 스크립트에서 사용할 수 있습니다. 그러나 이는 ", _jsx(_components.strong, {
        children: "구성에서 환경 변수를 고려하는 것을 훨씬 더 쉽게 우연히 잊어버릴 수 있게 하여"
      }), " 작업이 캐시에 히트해서는 안 될 때 캐시에 히트할 수 있도록 합니다."]
    }), "\n", _jsx(_components.p, {
      children: "예를 들어, API에서 데이터를 가져오는 애플리케이션에 일부 코드가 있고, 기본 URL에 대한 환경 변수를 사용할 수 있습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/data-fetcher.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " data"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " fetch"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "`"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "${"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "process"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "env"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "MY_API_URL"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "}"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "/resource/1`"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ");"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["그런 다음 프리뷰 환경을 대상으로 하는 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " 값을 사용하여 애플리케이션을 빌드합니다. 애플리케이션을 배포할 준비가 되면 프로덕션용으로 빌드하고 캐시 히트를 확인합니다 - ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), " 변수 값이 변경되었음에도 불구하고! ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), "이 변경되었지만 Turborepo는 프로덕션의 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), "이 아닌 프리뷰 환경의 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), "을 사용하는 애플리케이션 버전을 캐시에서 복원했습니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Loose Mode를 사용하는 경우 ", _jsx(_components.code, {
        children: "MY_API_URL"
      }), "은 ", _jsx(_components.strong, {
        children: "작업 해시에 고려되지 않았음에도 불구하고"
      }), " 작업 런타임에서 사용할 수 있습니다. 이 작업이 실패할 가능성을 높이고 이러한 잘못된 구성으로부터 보호하기 위해 ", _jsx(_components.a, {
        href: "#strict-mode",
        children: "Strict Mode"
      }), "를 선택하는 것이 좋습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "platform-환경-변수",
      children: "Platform 환경 변수"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com/new?ref=turborepo",
        children: "Vercel"
      }), "에 애플리케이션을 배포할 때 프로젝트에 이미 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/projects/environment-variables",
        children: "환경 변수"
      }), "가 구성되어 있을 가능성이 높습니다. Turborepo는 이러한 변수를 ", _jsx(_components.code, {
        children: "turbo.json"
      }), " 구성과 자동으로 확인하여 ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#adding-environment-variables-to-task-hashes",
        children: "고려했는지"
      }), " 확인하고 누락된 변수에 대해 경고합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이 기능은 ", _jsx(_components.code, {
        children: "TURBO_PLATFORM_ENV_DISABLED=false"
      }), "를 설정하여 비활성화할 수 있습니다."]
    }), "\n", _jsxs(_components.h2, {
      id: "env-파일-처리하기",
      children: [_jsx(_components.code, {
        children: ".env"
      }), " 파일 처리하기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: ".env"
      }), " 파일은 로컬에서 애플리케이션 작업을 할 때 유용합니다. ", _jsxs(_components.strong, {
        children: ["Turborepo는 ", _jsx(_components.code, {
          children: ".env"
        }), " 파일을 작업의 런타임에 로드하지 않으며"]
      }), ", 프레임워크 또는 ", _jsx(_components.a, {
        href: "https://www.npmjs.com/package/dotenv",
        children: _jsx(_components.code, {
          children: "dotenv"
        })
      }), "와 같은 도구에서 처리하도록 남겨둡니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["그러나 ", _jsx(_components.code, {
        children: "turbo"
      }), "가 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일의 값 변경 사항을 알고 해싱에 사용할 수 있도록 하는 것이 중요합니다. 빌드 간에 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일의 변수를 변경하면 ", _jsx(_components.code, {
        children: "build"
      }), " 작업은 캐시를 놓쳐야 합니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["이를 위해 파일을 ", _jsx(_components.a, {
        href: "/docs/reference/configuration#inputs",
        children: _jsx(_components.code, {
          children: "inputs"
        })
      }), " 키에 추가합니다:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // 모든 작업 해시"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// `build` 작업 해시만"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.h3, {
      id: "여러-env-파일",
      children: ["여러 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "*"
      }), "를 사용하여 여러 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일을 한 번에 캡처할 수 있습니다."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./turbo.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"globalDependencies\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\".env\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: " // 모든 작업 해시"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"tasks\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"build\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      \"inputs\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"$TURBO_DEFAULT$\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \".env*\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "] "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "// `build` 작업 해시만"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(Callout, {
      type: "info",
      children: _jsxs(_components.p, {
        children: [_jsx(_components.code, {
          children: ".env"
        }), " 파일은 환경 변수가 ", _jsxs(_components.a, {
          href: "/docs/reference/configuration#env",
          children: [_jsx(_components.code, {
            children: "env"
          }), " 키"]
        }), "에\n추가되지 않은 경우에도 작업 런타임에 변수를 로드할 수 있습니다. CI 및 프로덕션\n빌드의 경우 빌드를 위한 환경 변수를 ", _jsx(_components.code, {
          children: "env"
        }), " 키에 추가했는지 확인하세요."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "모범-사례",
      children: "모범 사례"
    }), "\n", _jsxs(_components.h3, {
      id: "패키지에서-env-파일-사용하기",
      children: ["패키지에서 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일 사용하기"]
    }), "\n", _jsxs(_components.p, {
      children: ["리포지토리의 루트에 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일을 사용하는 것은 권장되지 않습니다. 대신 ", _jsx(_components.code, {
        children: ".env"
      }), " 파일을 사용하는 패키지에 배치하는 것이 좋습니다."]
    }), "\n", _jsx(_components.p, {
      children: "이 방법은 환경 변수가 각 애플리케이션의 런타임에 개별적으로 존재하므로 애플리케이션의 런타임 동작을 더 밀접하게 모델링합니다. 또한 monorepo가 확장됨에 따라 이 방법을 사용하면 각 애플리케이션의 환경을 더 쉽게 관리할 수 있어 애플리케이션 간 환경 변수 누출을 방지할 수 있습니다."
    }), "\n", _jsx(Callout, {
      type: "good-to-know",
      children: _jsxs(_components.p, {
        children: ["monorepo로 점진적으로 마이그레이션할 때 루트 ", _jsx(_components.code, {
          children: ".env"
        }), " 파일을 사용하는 것이 더\n쉬울 수 있습니다. ", _jsx(_components.a, {
          href: "https://www.npmjs.com/package/dotenv",
          children: "dotenv"
        }), "와 같은 도구는\n다른 위치에서 ", _jsx(_components.code, {
          children: ".env"
        }), " 파일을 로드할 수 있습니다."]
      })
    }), "\n", _jsxs(_components.h3, {
      id: "eslint-config-turbo-사용하기",
      children: [_jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " 사용하기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: [_jsx(_components.code, {
          children: "eslint-config-turbo"
        }), " 패키지"]
      }), "는 ", _jsx(_components.code, {
        children: "turbo.json"
      }), "에 나열되지 않은 코드에서 사용되는 환경 변수를 찾는 데 도움이 됩니다. 이를 통해 모든 환경 변수가 구성에서 고려되도록 할 수 있습니다."]
    }), "\n", _jsx(_components.h3, {
      id: "런타임에-환경-변수-생성-또는-변경-피하기",
      children: "런타임에 환경 변수 생성 또는 변경 피하기"
    }), "\n", _jsx(_components.p, {
      children: "Turborepo는 작업 시작 시 작업의 환경 변수를 해싱합니다. 작업 중에 환경 변수를 생성하거나 변경하면 Turborepo는 이러한 변경 사항을 알지 못하고 작업 해시에 고려하지 않습니다."
    }), "\n", _jsx(_components.p, {
      children: "예를 들어, Turborepo는 아래 예제의 인라인 변수를 감지할 수 없습니다:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "./apps/web/package.json",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  \"scripts\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "    \"dev\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"export MY_VARIABLE=123 && next dev\""
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "MY_VARIABLE"
      }), "은 ", _jsx(_components.code, {
        children: "dev"
      }), " 작업이 시작된 ", _jsx(_components.em, {
        children: "후에"
      }), " 환경에 추가되므로 ", _jsx(_components.code, {
        children: "turbo"
      }), "는 해싱에 사용할 수 없습니다."]
    }), "\n", _jsx(_components.h2, {
      id: "예제",
      children: "예제"
    }), "\n", _jsx(_components.p, {
      children: "다음은 몇 가지 인기 있는 프레임워크에 대한 적절한 환경 변수 구성의 예입니다:"
    }), "\n", _jsxs(Accordions, {
      children: [_jsxs(Accordion, {
        title: "Next.js",
        children: [_jsxs(_components.p, {
          children: ["아래 ", _jsx(_components.code, {
            children: "turbo.json"
          }), "은 다음을 표현합니다:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "build"
            }), " 및 ", _jsx(_components.code, {
              children: "dev"
            }), " 작업은 ", _jsx(_components.code, {
              children: "MY_API_URL"
            }), " 및 ", _jsx(_components.code, {
              children: "MY_API_KEY"
            }), " 변경 사항에 대해 서로 다른 해시를 가집니다."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "build"
            }), " 및 ", _jsx(_components.code, {
              children: "dev"
            }), " 작업에는 Next.js에서 지원하는 .env 파일이 포함됩니다."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "test"
            }), " 작업은 환경 변수를 사용하지 않으므로 ", _jsx(_components.code, {
              children: "env"
            }), " 키가 생략됩니다. (테스트 구조에 따라 ", _jsx(_components.code, {
              children: "test"
            }), " 작업에 ", _jsx(_components.code, {
              children: "env"
            }), " 키가 필요할 수 있습니다.)"]
          }), "\n"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"env\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"MY_API_URL\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"MY_API_KEY\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"test\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {}"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      }), _jsxs(Accordion, {
        title: "Vite",
        children: [_jsxs(_components.p, {
          children: ["아래 ", _jsx(_components.code, {
            children: "turbo.json"
          }), "은 다음을 표현합니다:"]
        }), _jsxs(_components.ul, {
          children: ["\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "build"
            }), " 및 ", _jsx(_components.code, {
              children: "dev"
            }), " 작업은 ", _jsx(_components.code, {
              children: "MY_API_URL"
            }), " 및 ", _jsx(_components.code, {
              children: "MY_API_KEY"
            }), " 변경 사항에 대해 서로 다른 해시를 가집니다."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "build"
            }), " 및 ", _jsx(_components.code, {
              children: "dev"
            }), " 작업에는 Vite에서 지원하는 .env 파일이 포함됩니다."]
          }), "\n", _jsxs(_components.li, {
            children: [_jsx(_components.code, {
              children: "test"
            }), " 작업은 환경 변수를 사용하지 않으므로 ", _jsx(_components.code, {
              children: "env"
            }), " 키가 생략됩니다. (테스트 구조에 따라 ", _jsx(_components.code, {
              children: "test"
            }), " 작업에 ", _jsx(_components.code, {
              children: "env"
            }), " 키가 필요할 수 있습니다.)"]
          }), "\n"]
        }), _jsx(_Fragment, {
          children: _jsx(_components.pre, {
            className: "shiki shiki-themes css-variables css-variables",
            style: {
              "--shiki-light": "var(--shiki-foreground)",
              "--shiki-dark": "var(--shiki-foreground)",
              "--shiki-light-bg": "var(--shiki-background)",
              "--shiki-dark-bg": "var(--shiki-background)"
            },
            tabIndex: "0",
            title: "./turbo.json",
            icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M 6,1 C 4.354992,1 3,2.354992 3,4 v 16 c 0,1.645008 1.354992,3 3,3 h 12 c 1.645008,0 3,-1.354992 3,-3 V 8 7 A 1.0001,1.0001 0 0 0 20.707031,6.2929687 l -5,-5 A 1.0001,1.0001 0 0 0 15,1 h -1 z m 0,2 h 7 v 3 c 0,1.645008 1.354992,3 3,3 h 3 v 11 c 0,0.564129 -0.435871,1 -1,1 H 6 C 5.4358712,21 5,20.564129 5,20 V 4 C 5,3.4358712 5.4358712,3 6,3 Z M 15,3.4140625 18.585937,7 H 16 C 15.435871,7 15,6.5641288 15,6 Z\" fill=\"currentColor\" /></svg>",
            children: _jsxs(_components.code, {
              children: [_jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "{"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "  \"tasks\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"build\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"env\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "\"MY_API_URL\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: " \"MY_API_KEY\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "]"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.production\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"dev\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {"
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "      \"inputs\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " ["
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \"$TURBO_DEFAULT$\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.local\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env.development\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-string-expression)",
                    "--shiki-dark": "var(--shiki-token-string-expression)"
                  },
                  children: "        \".env\""
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "      ]"
                })
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "    }"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ","
                })]
              }), "\n", _jsxs(_components.span, {
                className: "line",
                children: [_jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-keyword)",
                    "--shiki-dark": "var(--shiki-token-keyword)"
                  },
                  children: "    \"test\""
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-token-punctuation)",
                    "--shiki-dark": "var(--shiki-token-punctuation)"
                  },
                  children: ":"
                }), _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: " {}"
                })]
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "  }"
                })
              }), "\n", _jsx(_components.span, {
                className: "line",
                children: _jsx(_components.span, {
                  style: {
                    "--shiki-light": "var(--shiki-foreground)",
                    "--shiki-dark": "var(--shiki-foreground)"
                  },
                  children: "}"
                })
              })]
            })
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "문제-해결",
      children: "문제 해결"
    }), "\n", _jsxs(_components.h3, {
      id: "--summarize-사용하기",
      children: [_jsx(_components.code, {
        children: "--summarize"
      }), " 사용하기"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsxs(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: [_jsx(_components.code, {
          children: "--summarize"
        }), " 플래그"]
      }), "를 ", _jsx(_components.code, {
        children: "turbo run"
      }), " 명령에 추가하여 작업에 대한 데이터를 요약하는 JSON 파일을 생성할 수 있습니다. ", _jsx(_components.code, {
        children: "globalEnv"
      }), " 및 ", _jsx(_components.code, {
        children: "env"
      }), " 키의 diff를 확인하면 구성에서 누락되었을 수 있는 환경 변수를 식별하는 데 도움이 됩니다."]
    }), "\n", _jsx(_components.h2, {
      id: "다음-단계",
      children: "다음 단계"
    }), "\n", _jsxs(_components.p, {
      children: ["환경 변수를 고려했으면 ", _jsx(_components.code, {
        children: "turbo"
      }), "의 속도로 애플리케이션을 빌드하고 확인하고 배포하는 CI 파이프라인을 구축할 준비가 되었습니다."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
